export const iconFontAwesomeShoppingGifts = (
	<i className="fa-solid fa-gifts"></i>
);
